// Time helpers — QaTestology displays timestamps in IST (Asia/Kolkata, UTC+5:30).

const IST_OPTS = {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
};

const IST_OPTS_SHORT = {
  timeZone: "Asia/Kolkata",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
};

const IST_OPTS_DATE = {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "short",
  day: "2-digit",
};

function toDate(input) {
  if (!input) return null;
  if (input instanceof Date) return input;
  try {
    // Backend stores ISO with tz. Also handle plain YYYY-MM-DD.
    const d = new Date(input);
    if (Number.isNaN(d.getTime())) return null;
    return d;
  } catch {
    return null;
  }
}

export function formatIST(input, { short = false, dateOnly = false } = {}) {
  const d = toDate(input);
  if (!d) return "";
  const opts = dateOnly ? IST_OPTS_DATE : short ? IST_OPTS_SHORT : IST_OPTS;
  try {
    return `${d.toLocaleString("en-IN", opts)} IST`;
  } catch {
    return d.toISOString();
  }
}

export function formatRelativeIST(input) {
  const d = toDate(input);
  if (!d) return "";
  const diffMs = Date.now() - d.getTime();
  const sec = Math.max(0, Math.floor(diffMs / 1000));
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return formatIST(input, { short: true });
}
